import apiURL from'./apiURL';

// types of action
const Types = {
  PAYSCHEDULE_UPDATING: "PAYSCHEDULE_UPDATING",
  PAYSCHEDULE_UPDATE: "PAYSCHEDULE_UPDATE",
  PAYSCHEDULE_DOWNLOADING: "PAYSCHEDULE_DOWNLOADING",
  PAYSCHEDULE_ADD: "PAYSCHEDULE_ADD",
  PAYSCHEDULE_UPDATE_FIELD: "PAYSCHEDULE_UPDATE_FIELD"
};

const updateSetting = (id, field, newValue, newCompany, fieldType) => ({
  type: Types.PAYSCHEDULE_UPDATE_FIELD,
  id,
  field,
  newValue,
  newCompany,
  fieldType
})

const paySchedulesUpdating = () => ({
  type: Types.PAYSCHEDULE_UPDATING,
});

const paySchedulesUpdated = response => ({
  type: Types.PAYSCHEDULE_UPDATE,
  payload: response
});

const addPaySchedule = ({ parent, newCompany, payScheduleType }) => ({
  type:Types.PAYSCHEDULE_ADD,
  parent,
  newCompany,
  payScheduleType
});

const removePaySchedule = (id) => {
  return (dispatch, getState) => {
    dispatch(paySchedulesUpdating())
    fetch(apiURL + `/settings/paySchedules` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(paySchedulesUpdated(data))
    })
  }
};

const payScheduleGetList = () => {
  return (dispatch, getState) => {

    dispatch(paySchedulesUpdating())
    fetch(apiURL + `/settings/paySchedules` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(paySchedulesUpdated(data))
    })
  }
};

const downloadStatus = (id,type,processing) => ({
  type: Types.PAYSCHEDULE_DOWNLOADING,
  id,
  type,
  processing
});

const download = (id,type) => {
  return (dispatch, getState) => {
    
    dispatch(downloadStatus(id,type,true))

    fetch(apiURL + `/settings/payslip/${id}/download` , {
        credentials: 'include',
        method: 'GET',
        // body: JSON.stringify(body),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {

      const popup = window.open(data.signedURL);
      if (!popup || popup.closed || typeof popup.closed=='undefined'){
            //Worked For IE and Firefox
            alert("Popup Blocker is enabled! Please add this site to your exception list.");
      }

      dispatch(downloadStatus(id,type,false))
    })
  }
};


const Actions = {
  addPaySchedule,
  payScheduleGetList,
  removePaySchedule,
  download,
  updateSetting
};

export {Types, Actions};